import React from "react";
import { useSelector } from "react-redux";
import "./sectionEightThemeThree.css";

function SectionEightThemeThree() {
  const data: any = useSelector<any>((state) => state?.homeJsonList);
  const section_8 = data.theme_3.home.section_8;

  return (
    <section className="s8about">
      <div className="container">
        <div className="row align-items-center">

          {/* ── Left: content ── */}
          <div className="col-lg-6 col-md-12">
            <div className="s8about__content">
              <span className="s8about__eyebrow">About Us</span>

              <h2
                className="s8about__title"
                style={{ color: `#${section_8?.h2color}` || undefined }}
              >
                {section_8.title}
              </h2>

              <p
                className="s8about__para"
                style={{ color: `#${section_8?.paracolor}` || undefined }}
              >
                {section_8.paragraph}
              </p>

              <div className="s8about__cards">
                {section_8.card_section.collection.map(
                  (item: any, idx: number) => (
                    <div className="s8about__card" key={idx}>
                      <div className="s8about__icon">
                        <img src={item.collection_image} alt="" />
                      </div>
                      <div className="s8about__card-body">
                        <h4
                          className="s8about__card-title"
                          style={{
                            color: `#${section_8?.h3color}` || undefined,
                          }}
                        >
                          {item.collection_title}
                        </h4>
                        <p
                          className="s8about__card-para"
                          style={{
                            color: `#${section_8?.paracolor}` || undefined,
                          }}
                        >
                          {item.collection_paragraph}
                        </p>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          {/* ── Right: image ── */}
          <div className="col-lg-6 col-md-12">
            <div className="s8about__img-col">
              <div className="s8about__dots">
                {Array.from({ length: 16 }).map((_, i) => (
                  <span key={i} />
                ))}
              </div>
              <div className="s8about__img-wrap">
                <img
                  className="s8about__img"
                  src={section_8.section_image}
                  alt=""
                />
                <div className="s8about__badge">
                  <div className="s8about__badge-icon">
                    <i className="uil uil-shield-check" />
                  </div>
                  <div>
                    <p className="s8about__badge-num">100%</p>
                    <p className="s8about__badge-label">Trusted Service</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default SectionEightThemeThree;
